import React, {useState, useEffect} from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { stockData } from "../../data";
import "../../services/authServices";
import "../../css/Home.css";
import authServices from "../../services/authServices";

const Home = () => {
  const [showUpdates, setShowUpdates] = useState([]);
  const [find, setFind] = useState("")
  const navigate = useNavigate();
  const handleOnClick = (page) => () => {
    window.scrollTo(0, 0);
    navigate(`/${page}`);
  };
  const [like, setLike] = useState("true");
  const [Update, setUpdate] = useState({ rate: "", subject: "", overall: "", activities:"", school:"", body:""});
  const { id } = useParams();
  const [CommunityPost, setCommunityPost] = useState(false);
  const handleSearch = (e) => {
    if (find == "Dallas") {
      e.preventDefault();
      navigate(`/communities/Dallas`);
    } 
    else if(find == "Allen" ) {
      e.preventDefault();
      navigate(`communities/Allen`);
      
    } 
    else if(find == "Garland" ) {
      e.preventDefault();
      navigate(`communities/Garland`);

    } 
    else if(find == "Frisco" ) {
      e.preventDefault();
      navigate(`communities/Frisco`);

    } 
    else if(find == "Richardson" ) {
      e.preventDefault();
      navigate(`communities/Richardson`);

    } 
    else if(find == "Fort Worth" ) {
      e.preventDefault();
      navigate(`communities/Fort Worth`);

    } 
    
    else {
        alert("This city is out of our services")
    }}
    const handleCreatePost = () => {
      setCommunityPost(true);
      console.log(handleCreatePost)
    }
    useEffect(() => {
      authServices.getUpdates().then((res) => {
          if (res.data.error) {
              alert(res.data.error);
          }
          setShowUpdates(res.data);
      });
  }, []);
  
  // const[value,setValue] = useState('');
  return (
    <div class="home" id="main" >
      <div class="home-container">
        <h1 class="home-heading">Word On The Street</h1>
          <p class="home-description">Find more about your community of interest</p>
      <div class="search-inner">
          <input type ="text" valuenput="Searchbar" placeholder="Search for communities" style = {{borderRadius: "20px 20px 20px 20px" ,height: "50px", marginLeft:"400px"}} onChange={e => setFind(e.target.value)} >
          </input>
          <div className="contact-bottom">
          <button onClick={handleSearch}>
            Click
          </button>
          </div>
          
          {/* {stockData.map((data, key) => {
            return (
            <div key={key}>
            {data.city}
          </div>
          )
          })} */}
           <Container className="contact-bottom">
               {showUpdates.map((Updates, index) => (
                    <Col className="display_box">
                        <Col>
                            <p ><strong>Overall Rating:</strong> {Updates.rate}</p>
                            <p >City: {Updates.subject}</p>
                            <p >Activities Rating: {Updates.activities}</p>
                            <p >Education Rating: {Updates.school}</p>
                            
                        </Col>
                        <Col>
                        <p >Body: {Updates.body}</p>
                        </Col>
                    </Col>
                    // </Row>
                 

                ))}
          </Container>
        </div>
      </div>
      <div className="right"></div>
    </div>
  );
};

export default Home;
